import { IListPaginated } from '@interfaces/api/IRequestsReturn'
import { IMessage } from '@interfaces/iMessage'
import { IListTableSales, IPdfLink, ITableSales, ITemplate } from '@interfaces/tables/tableSales'
import api from '@services/api/server'
import { IParamsUrl } from '@utils/getQueryParams/getQueryParams'

export default class TableSalesService {
    public static async create(values: FormData): Promise<ITableSales> {
        return (await api.post<ITableSales>('/sales-table', values)).data
    }

    public static async update(values: FormData, id: number): Promise<ITableSales> {
        return (await api.put<ITableSales>(`/sales-table/${id}`, values)).data
    }

    public static async list(params?: IParamsUrl): Promise<IListPaginated<IListTableSales>> {
        return (
            await api.get<IListPaginated<IListTableSales>>('/sales-table', {
                params,
            })
        ).data
    }

    public static async getOne(id: number): Promise<ITableSales> {
        return (await api.get<ITableSales>(`/sales-table/${id}`)).data
    }

    public static async getTemplate(id: number): Promise<ITemplate> {
        return (await api.get<ITemplate>(`/sales-table/template/${id}`)).data
    }

    public static async getPdfLink(id: number): Promise<IPdfLink> {
        return (await api.get<IPdfLink>(`/sales-table/${id}/pdf`)).data
    }

    public static async delete(id: number): Promise<IMessage> {
        return (await api.delete<IMessage>(`/sales-table/${id}`)).data
    }
}
